import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import useAuthentication from 'hooks/use-authentication';
import useDateTime from 'hooks/use-date-time';
import Loader from 'components/loader/loader';
import EXAM_QUERY from 'queries/get-exam-by-id.graphql';
const ProtectedByDatesRoute = ({ children }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { getExamIdFromToken } = useAuthentication();
    const { currentDateTime, stopInterval } = useDateTime();
    const [canAccess, setCanAccess] = useState(false);
    const { data, loading, error } = useQuery(EXAM_QUERY, {
        variables: {
            id: getExamIdFromToken(),
        },
    });
    useEffect(() => {
        if (!data || !currentDateTime) {
            return;
        }
        if (isExamAvailable(new Date(data.exam.availableAt), new Date(data.exam.closingAt), currentDateTime)) {
            setCanAccess(true);
        }
        else {
            navigate('/welcome');
        }
        stopInterval();
    }, [data, currentDateTime]);
    const isExamAvailable = (availableAt, closingAt, current) => {
        return availableAt <= current && current <= closingAt;
    };
    return (_jsxs(_Fragment, { children: [loading && _jsx(Loader, { isFullWith: true }, void 0), error && (_jsx("div", Object.assign({ className: "container--content container--fixed" }, { children: _jsx("h3", { children: t('GENERAL.TRY_AGAIN') }, void 0) }), void 0)), canAccess && children] }, void 0));
};
export default ProtectedByDatesRoute;
